import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import * as userApi from '../../lib/api/user';

const salesmanOptions = [
  { usrNm: '김경운', usrUuid: 'A36D8313-1EFE-4DC0-B212-5FE4D2BFE2FE' },
  { usrNm: '최광수', usrUuid: 'F5A7ADE6-4300-4EF2-A0EA-0A0DB1C5A4BE' },
  { usrNm: '김인종', usrUuid: '9BD19B57-91CD-466B-B977-EC4AFD212406' },
  { usrNm: '양진섭', usrUuid: '544ea5b5-6c91-45db-865b-edf107268d7a' },
  { usrNm: '김규덕', usrUuid: '6F078D3E-23C8-4657-B1C4-ED1896915D69' },
  { usrNm: '심  혁', usrUuid: '8c75f20f-1e93-4900-9884-279a62226f55' },
  { usrNm: '조행래', usrUuid: '89CA6C28-7C35-4A0F-BDF0-EC02E48C07BF' },
  { usrNm: '박재욱', usrUuid: 'DDE6B4A7-33C8-43B9-8BE4-A6930E948DCC' },
  { usrNm: '박형석', usrUuid: '9A64EA44-3348-4144-B796-6C6537581E65' },
  { usrNm: '이창준', usrUuid: '61AED28F-D57D-4725-8FC2-3C3585B0E336' },
];

const SalesmanSelectbox = ({ selectedUsrUuid, onChange }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchSalesmans = async () => {
      try {
        const res = await userApi.getSalesUsers();
        if (res.data.result === 'success') {
          setOptions(res.data.list);
        }
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }
    };

    fetchSalesmans();
  }, []);

  return (
    <FormControl variant="standard" size="small" fullWidth>
      <Select
        variant="outlined"
        size="small"
        labelId="selected-usr-label"
        id="selected-usr"
        displayEmpty
        sx={{ width: 120 }}
        value={selectedUsrUuid || ''}
        onChange={(e) => onChange(e.target.value)}
      >
        <MenuItem value="">영업사원을 선택하세요.</MenuItem>
        {options.length > 0 &&
          options.map((item, index) => (
            <MenuItem key={index} value={item?.usrUuid}>
              {item?.usrNm}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default SalesmanSelectbox;
